import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render management accounts section for FAQ Page
 */
const ManagementAccountsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="management-accounts-section-component"
    >
      <AccordionV2
        testId="management-accounts"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="5. If the management accounts are not up to date, is it still acceptable?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 pb-2 pt-6">
          <p>
            Yes, we will accept accounts that are no longer than six months old.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ManagementAccountsSection;
